import React from 'react';
import classNames from 'classnames';

import { FavoriteMatchesMenuState } from '../../types';

import { Spinner } from 'app/design-system/components/Spinner';
import { useTranslation } from 'app/lang';

import MatchMenuItem from '../StagesAndMatchesMenuItems/MatchMenuItem';

import dictionary from './FavoritesMenuLayer.dictionary.json';

import styles from 'app/modules/LeftMenu/styles/LeftMenu.module.scss';

type FavoriteMatchesMenuItemsProps = {
  menu: FavoriteMatchesMenuState;
};

const FavoriteMatchesMenuItems: React.FC<FavoriteMatchesMenuItemsProps> = ({
  menu: { loading, items },
}) => {
  const { t } = useTranslation();

  return (
    <>
      <li className={classNames(styles.favoritesGroupTitle, styles.nextPriorityGroup)}>
        {t(dictionary.matches)}
      </li>

      {(loading && !items.length) && (
        <Spinner size={24} />
      )}

      {items.map((item) => (
        <MatchMenuItem entry={item}
                       key={item.key} />
      ))}
    </>
  );
};

export default FavoriteMatchesMenuItems;
